
import Modal from 'react-bootstrap/Modal';
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

import hands_img from '../../../assets/images/high-five-hand.svg';
import { Link } from "react-router-dom";
import { TitleH2 } from '../../../components/TitleH2';
import { Text } from '../../../components/Text';
import { Button } from '../../../components/Button';

export default function VideoCompletedModal (props) {

    const {show, onClose, folderData, endedFolder} = props
    const t = useSelector(selectTranslations)

    return (
        <Modal
            show={show}
            onHide={onClose}
            keyboard={false}
            centered
        >
            <Modal.Body className="text-center">
                <img src={hands_img} alt="" className="mb-2 mx-auto" />
                <TitleH2 className="text-center">{t.folder.video_completed}</TitleH2>
                <Text className="text-center mb-4">{t.folder.video_completed_text}</Text>
                <Link to={`/folder/${folderData?.folder_id}`}>
                    <Button className="mt-2 w-100 mx-auto" color="primary">{t.folder.back_to_folder}</Button>
                </Link>
                <Button className="mt-2 w-100 mx-auto" onClick={onClose} color="secondary">{t.modals.close}</Button>
            </Modal.Body>
        </Modal>
    )
}